// src/services/servicesService.js
import apiClient from './apiClient.js'

export const servicesService = {
    // Get services for public website
    getServices(params = {}) {
        return apiClient.get('/services', { params })
    },

    // Get services for admin panel with pagination
    getServicesAdmin(params = {}) {
        return apiClient.get('/services/admin', { params })
    },

    getServiceBySlug(slug) {
        return apiClient.get(`/services/slug/${slug}`)
    },

    createService(data) {
        return apiClient.post('/services', data)
    },

    updateService(id, data) {
        return apiClient.put(`/services/${id}`, data)
    },

    toggleServiceStatus(id) {
        return apiClient.patch(`/services/${id}/toggle-status`)
    },

    deleteService(id) {
        return apiClient.delete(`/services/${id}`)
    },
}